export enum ChartPricesRange {
  WEEK = '1W',
  MONTH = '1M',
  MONTH6 = '6M',
  YTD = 'YTD',
  YEAR = '1Y',
  YEAR5 = '5Y',
  ALL = 'All',
}
